import {createAction} from "redux-act";

export const getVotesAction = createAction();
export const checkLocalVotes = createAction();

export interface IVote {
	gameId: number;
	playerId: number;
}

export const addVoteAction = createAction<IVote>();
export const addVotesAction = createAction<IVote[]>();
export const setConfirmModalState = createAction<IVote | null>();

interface IVoteResponse {
	id?: number;
	userId?: number | null;
	gameId: number;
	playerId: number;
}

export const addVoteActionSuccess = createAction<IVoteResponse>();
export const addVotesActionSuccess = createAction<{votes: IVoteResponse[]}>();
export const addVoteActionFailed = createAction<Error["message"]>();

export const selectMatchAction = createAction<number | null>();

export const saveLocalVotes = createAction();
